// removed by extract-text-webpack-plugin
module.exports = {"tagsContainer":"_2gFM","tag":"_28xF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/Hero/Tags/styles.scss
// module id = 526
// module chunks = 0